import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core'
import { ModalContainerComponent } from '../../_common/modal-container/modal-container.component'

@Component({
  selector: 'modal-loading',
  templateUrl: './modal-loading.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ModalLoadingComponent {
  @ViewChild('modal') childModal: ModalContainerComponent
  constructor() {}

  async showChildModal() {
    this.childModal.showChildModal()
  }

  hideChildModal() {
    this.childModal.hideChildModal()
  }

  close() {
    // if (!this.isProgressFinish) {
    //   if (confirm(this.translateService.instant('modal-bulk-edits.terminate-action'))) {
    //     this.wasKilled = true
    //   } else return
    // }
    // this.setDefaultValues()
    // this.hideChildModal()
  }
}
